import { useSelector } from 'react-redux'
import { VerticalLogo } from '../../assets/images'
import PageLayout from '../../layouts/PageLayout'
import LoginSuccess from '../../features/login/components/LoginSuccess'
import LoginFail from '../../features/login/components/LoginFail'
import LoginForm from '../../features/login/components/LoginForm'

function LoginPage() {
  const { isAuthorized, isAuthenticated } = useSelector(
    (state) => state.auth.data
  )
  const isLoginSuccessScreen = isAuthenticated && isAuthorized
  const isLoginFailScreen = isAuthenticated && !isAuthorized
  const isLoginScreen = !isAuthenticated && !isAuthorized

  return (
    <PageLayout className="flex flex-col items-center justify-center gap-5 bg-main-background text-gray-accent">
      <figure>
        <img
          src={VerticalLogo}
          className="mb-6 w-[360px] sm:w-[430px]"
          alt="NEU Reader Logo"
        />
      </figure>
      {isLoginSuccessScreen && <LoginSuccess />}
      {isLoginFailScreen && <LoginFail />}
      {isLoginScreen && <LoginForm />}
    </PageLayout>
  )
}

export default LoginPage
